export const GET_TRANSACTION = 'MARRIAGE_CERTIFICATES/get_transaction';
export const APPROVE_TRANSACTION = 'MARRIAGE_CERTIFICATES/approve_transaction';
export const UPDATE_TRANSACTION = 'MARRIAGE_CERTIFICATES/update_transaction';
export const SHOW_TRANSACTION = 'MARRIAGE_CERTIFICATES/show_transaction';
export const START_ASSESSMENT = 'MARRIAGE_CERTIFICATES/start_assessment';
export const GET_SETTINGS = 'MARRIAGE_CERTIFICATES/get_settings';
export const UPDATE_TEST_STATUS = 'MARRIAGE_CERTIFICATES/update_health_status';
export const GET_MARRIAGE_ARCHIVE =
  'MARRIAGE_CERTIFICATES/get_MARRIAGE_CERTIFICATES_archive';
export const GET_PHOTO = 'MARRIAGE_CERTIFICATES/getPhoto';
export const ASSESS_RECEIPT = 'MARRIAGE_CERTIFICATES/assess_receipt';
export const EDIT_MARRIAGE = 'MARRIAGE_CERTIFICATE/edit_marriage';
export const UPDATE_REGISTRY = 'MARRIAGE_CERTIFICATE/update_registry';

export const DEPENDENCIES = {
  health_certificate_amount: {
    label: 'Health Certificate',
  },
  occupational_permit_amount: {
    label: 'Occupational Permit',
  },
  card_type: {
    label: 'CARD TYPE',
  },
  stool_amount: {
    label: 'Stool',
  },
  sputum_amount: {
    label: 'Sputum',
  },
  drug_test_amount: {
    label: 'Drug Test',
  },
  rpr_syphilis_amount: {
    label: 'RPR Syphilis',
  },
  gram_stain: {
    label: 'Gram Stain',
  },
};

export const GENDER = [
  {
    label: 'MALE',
    value: 'MALE',
  },
  {
    label: 'FEMALE',
    value: 'FEMALE',
  },
];

export const FORM_DATA = {
  husband_first_name: '',
  husband_last_name: '',
  husband_middle_name: '',
  wife_first_name: '',
  wife_last_name: '',
  wife_middle_name: '',
  extension_name: '',
  gender: '',
  death_date: '',
  requestors_first_name: '',
  requestors_last_name: '',
  requestors_middle_name: '',
  search_by: '',
  registry_number: '',
};

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR.', value: 'JR.' },
  { label: 'SR.', value: 'SR.' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
];
